'use client';

import classnames from 'classnames';
import Box from '../../../atoms/Box/Box';
import Typography from '../../../atoms/Typography/Typography';
import type { DisclaimersField } from '../types';
import styles from '../Form.module.scss';

export type DisclaimersControlProps = {
  field: DisclaimersField;
  theme: 'dark' | 'light';
  direction: 'ltr' | 'rtl';
};

/**
 * Form control for disclaimer/terms text
 * @component
 * @param {DisclaimersControlProps} props - Component props
 * @returns {JSX.Element} Disclaimers control component
 */
const DisclaimersControl = ({ field, theme, direction }: DisclaimersControlProps) => {
  return (
    <Box pb={16} key={`form_field_${field.name}`}>
      <Typography
        variant="body"
        className={classnames(styles.terms, styles[theme])}
        size="extraSmall"
        direction={direction}
        theme={theme}
        color="gray-5"
      >
        {field.terms}
      </Typography>
    </Box>
  );
};

export default DisclaimersControl;
